import { useState, useEffect } from 'react';
import { useApp } from '../App';
import api from '../api';
import BackButton from '../components/BackButton';
import { useI18n } from '../i18n/index.jsx';

export default function InvoiceTemplates() {
  const { user, setPage } = useApp();
  const { t } = useI18n();
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({
    name: '',
    client_name: '',
    client_nip: '',
    service_name: '',
    price: '',
    vat_rate: '23',
  });

  useEffect(() => {
    loadTemplates();
  }, []);

  async function loadTemplates() {
    try {
      const saved = localStorage.getItem('invoice_templates');
      if (saved) {
        setTemplates(JSON.parse(saved));
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  }

  function saveTemplate() {
    if (!form.name || !form.service_name || !form.price) {
      alert('Заполните обязательные поля');
      return;
    }
    
    const newTemplate = {
      id: Date.now(),
      ...form,
      price: parseFloat(form.price),
      created_at: new Date().toISOString(),
    };
    
    const updated = [...templates, newTemplate];
    setTemplates(updated);
    localStorage.setItem('invoice_templates', JSON.stringify(updated));
    setShowForm(false);
    setForm({
      name: '',
      client_name: '',
      client_nip: '',
      service_name: '',
      price: '',
      vat_rate: '23',
    });
  }

  function deleteTemplate(id) {
    const updated = templates.filter(item => optpl.id !== id);
    setTemplates(updated);
    localStorage.setItem('invoice_templates', JSON.stringify(updated));
  }

  function useTemplate(template) {
    // Store in session and redirect to invoice creation
    sessionStorage.setItem('invoice_template', JSON.stringify(template));
    setPage('invoices_out');
  }

  if (loading) return <div className="page"><BackButton /><div className="loader">{t('common.loading')}</div></div>;

  return (
    <div className="page">
      <BackButton />
      <h1>📝 Шаблоны фактур</h1>

      {/* Info */}
      <div style={{
        background: 'rgba(99,102,241,0.1)',
        borderRadius: 12,
        padding: 16,
        marginBottom: 16,
      }}>
        <div style={{ fontWeight: 'bold', marginBottom: 4 }}>💡 Быстрое создание фактур</div>
        <div style={{ fontSize: 13, opacity: 0.8 }}>
          Сохраните часто используемые услуги и клиентов как шаблоны
        </div>
      </div>

      {/* Add Button */}
      {!showForm && (
        <button
          className="btn btn-primary"
          style={{ width: '100%', marginBottom: 16 }}
          onClick={() => setShowForm(true)}
        >
          ➕ Создать шаблон
        </button>
      )}

      {/* Form */}
      {showForm && (
        <div style={{
          background: 'rgba(255,255,255,0.05)',
          borderRadius: 12,
          padding: 20,
          marginBottom: 16,
        }}>
          <h3 style={{ marginTop: 0 }}>Новый шаблон</h3>
          
          <div style={{ marginBottom: 12 }}>
            <label style={{ display: 'block', marginBottom: 4, opacity: 0.7 }}>Название шаблона *</label>
            <input
              type="text"
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
              placeholder="Например: Консультация для ABC"
              style={{
                width: '100%', padding: 12, borderRadius: 8,
                border: '1px solid rgba(255,255,255,0.2)',
                background: 'rgba(255,255,255,0.05)', color: '#fff',
              }}
            />
          </div>

          <div style={{ marginBottom: 12 }}>
            <label style={{ display: 'block', marginBottom: 4, opacity: 0.7 }}>Клиент</label>
            <input
              type="text"
              value={form.client_name}
              onChange={(e) => setForm({ ...form, client_name: e.target.value })}
              placeholder="Название фирмы"
              style={{
                width: '100%', padding: 12, borderRadius: 8,
                border: '1px solid rgba(255,255,255,0.2)',
                background: 'rgba(255,255,255,0.05)', color: '#fff',
              }}
            />
          </div>

          <div style={{ marginBottom: 12 }}>
            <label style={{ display: 'block', marginBottom: 4, opacity: 0.7 }}>NIP клиента</label>
            <input
              type="text"
              value={form.client_nip}
              onChange={(e) => setForm({ ...form, client_nip: e.target.value })}
              placeholder="1234567890"
              style={{
                width: '100%', padding: 12, borderRadius: 8,
                border: '1px solid rgba(255,255,255,0.2)',
                background: 'rgba(255,255,255,0.05)', color: '#fff',
              }}
            />
          </div>

          <div style={{ marginBottom: 12 }}>
            <label style={{ display: 'block', marginBottom: 4, opacity: 0.7 }}>Услуга *</label>
            <input
              type="text"
              value={form.service_name}
              onChange={(e) => setForm({ ...form, service_name: e.target.value })}
              placeholder="Usługa konsultingowa"
              style={{
                width: '100%', padding: 12, borderRadius: 8,
                border: '1px solid rgba(255,255,255,0.2)',
                background: 'rgba(255,255,255,0.05)', color: '#fff',
              }}
            />
          </div>

          <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
            <div style={{ flex: 1 }}>
              <label style={{ display: 'block', marginBottom: 4, opacity: 0.7 }}>Цена (нетто) *</label>
              <input
                type="number"
                value={form.price}
                onChange={(e) => setForm({ ...form, price: e.target.value })}
                placeholder="1000"
                style={{
                  width: '100%', padding: 12, borderRadius: 8,
                  border: '1px solid rgba(255,255,255,0.2)',
                  background: 'rgba(255,255,255,0.05)', color: '#fff',
                }}
              />
            </div>
            <div style={{ width: 100 }}>
              <label style={{ display: 'block', marginBottom: 4, opacity: 0.7 }}>VAT %</label>
              <select
                value={form.vat_rate}
                onChange={(e) => setForm({ ...form, vat_rate: e.target.value })}
                style={{
                  width: '100%', padding: 12, borderRadius: 8,
                  border: '1px solid rgba(255,255,255,0.2)',
                  background: 'rgba(255,255,255,0.05)', color: '#fff',
                }}
              >
                <option value="23">23%</option>
                <option value="8">8%</option>
                <option value="5">5%</option>
                <option value="0">0%</option>
              </select>
            </div>
          </div>

          <div style={{ display: 'flex', gap: 8 }}>
            <button className="btn btn-primary" style={{ flex: 1 }} onClick={saveTemplate}>
              💾 Сохранить
            </button>
            <button className="btn" style={{ background: 'rgba(255,255,255,0.1)' }} onClick={() => setShowForm(false)}>
              Отмена
            </button>
          </div>
        </div>
      )}

      {/* Templates List */}
      {templates.length === 0 ? (
        <div style={{
          textAlign: 'center',
          padding: 32,
          background: 'rgba(255,255,255,0.05)',
          borderRadius: 12,
        }}>
          <div style={{ fontSize: 48, marginBottom: 12 }}>📝</div>
          <p style={{ opacity: 0.7 }}>{t('invoice_templates.no_templates')}</p>
        </div>
      ) : (
        <div className="list">
          {templates.map(opt => (
            <div key={optpl.id} style={{
              background: 'rgba(255,255,255,0.05)',
              borderRadius: 12,
              padding: 16,
              marginBottom: 8,
            }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
                <div style={{ fontWeight: 'bold' }}>{optpl.name}</div>
                <div style={{ fontWeight: 'bold', color: '#10b981' }}>
                  {tpl.price} PLN
                </div>
              </div>
              <div style={{ fontSize: 13, opacity: 0.7, marginBottom: 8 }}>
                {tpl.service_name}
                {tpl.client_name && ` • ${tpl.client_name}`}
              </div>
              <div style={{ display: 'flex', gap: 8 }}>
                <button className="btn btn-small btn-primary" style={{ flex: 1 }} onClick={() => useTemplate(t)}>
                  📄 Использовать
                </button>
                <button className="btn btn-small" style={{ background: 'rgba(239,68,68,0.3)' }} onClick={() => deleteTemplate(optpl.id)}>
                  🗑
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
